import React, {Component} from 'react';
//import {Document, Page} from 'react-pdf';
import{RESPONSE, API_BASE_URL} from '../../resources/constant';
import {getDBAName} from '../../Utilities/WSUtil';
import {retentionYears, allMonths} from '../../Utilities/DatePicker';
import {Link} from 'react-router-dom';
import {Row,Col,Form, Modal} from 'react-bootstrap';
import OverlayLoader from 'react-overlay-loading/lib/OverlayLoader';
import renderHTML from 'react-render-html';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn, MidCifBtn} from '../../theme/MorsTheme';
import MerchantPicker from '../../Utilities/MerchantPicker';
import axios from 'axios';

export default class SearchMerchantReport extends Component{

    constructor(props){
        super(props);               
        this.handleChange = this.handleChange.bind(this);        
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleChange = this.toggleChange.bind(this);        
        this.blurChange = this.blurChange.bind(this);
        this.isInputValid = this.isInputValid.bind(this);
        this.state = {          
            cu:JSON.parse(localStorage.getItem(RESPONSE)),   
            url:API_BASE_URL+'cad/merchant/getMerchRep?',                     
            //url:'localhost:8090/cad/merchant/getMerchRep?',                     
            checkedAllReport:false, 
            searchSingleId: '',
            fromMonth:'',
            fromYear:'',
            btnShow: false,
            file:[],
            fetchMessage:'',
            names:[]                                            
        };
    }       

    selectMerchantPicker = (mer) =>{
        this.setState({
            fetchMessage:'',
            searchSingleId: mer.id,
            names:{ legalName: mer.corpName, 
                    corpName: mer.dbaName}
        })
    }

    componentWillMount(){
        this.setState({
            btnShow: this.state.cu.user.allReportAccess,
            names:{legalName: '', corpName: ''},
            fetchMessage:''
        })
    }


    
    isInputValid(){                  
        if(this.state.searchSingleId === ''){                        
            alert('Merchant ID cannot be null.')            
            return false;
        }

        if(this.state.fetchMessage!=='' ){
                alert('Please input a valid Merchant ID.');            
                return false;
        }
    
        return true;
    }
    
    toggleChange = () => {
        this.setState({
            checkedAllReport: !this.state.checkedAllReport,
            names:{legalName: '', corpName: ''},
            fetchMessage:''
        });
      }

      blurChange(e){
        e.preventDefault();
        if(this.state.searchSingleId !== "") {               
            getDBAName(this.state.cu.user.userId, this.state.searchSingleId).then(response =>             
                ({
                    legalName: `${response.dbaName}`,
                    corpName: `${response.corpName}`
                })                                                
            ).then(names => this.setState({names,fetchMessage:''}))                
            .catch(error =>{            
                this.setState({
                    fetchMessage: 
                    `Sorry, the Merchant lD you're searching for does not exist in our system. <br/>
                    Please check the details you selected and try again. `,
                    names:{legalName: '', corpName: ''},
                })                                             
            })       
        }else{
            this.setState({
                //checkedAllReport: !this.state.checkedAllReport,
                names:{legalName: '', corpName: ''},
                fetchMessage:''
            });
        }
    }
        
    handleChange(e){
        this.setState(
            {                
                [e.target.id]: e.target.value   
            }
        )
        //alert("searchSingleId = " + this.state.searchSingleId)
        //alert("month = " + this.state.fromMonth)
        //alert("year = " + this.state.fromYear)
    }
//Marlon Added
    updateToAllDays(e){

        var fromYear = document.getElementById('fromYear').value;
        //this.setState.fromYear = fromYear;
        var fromMonth = document.getElementById('fromMonth').value;
        //this.setState.fromMonth = fromMonth;
        var valYear = (typeof fromYear !== 'undefined') ? fromYear : 0;
        var valMonth = (typeof fromMonth !== 'undefined') ? fromMonth : 0;

        this.setState({
            [e.target.id]: e.target.value, 
            //this.state.
            toAllDays: this.updateAllDays(valYear, valMonth)
        });

        //alert("searchSingleId = " + this.state.searchSingleId)
        //alert("month = " + this.state.fromMonth)
        //alert("year = " + this.state.fromYear)
        
    }

    updateAllDays(year, month){
        var selDate = new Date(year, month, 0);
        var arrResult = [];
        Array.from(Array(selDate.getDate())).map((e,i)=>i+1).forEach(function(value, idx){
            arrResult[idx+1] = value;
        });
        return arrResult;
    }

   
    handleSubmit(event) {
        event.preventDefault();   

        var varfromYear = document.getElementById('fromYear').value;
        //this.setState.fromYear = fromYear;
        var varfromMonth = document.getElementById('fromMonth').value;
        //this.setState.fromMonth = fromMonth;

        //alert("month = " + varfromMonth)
        //alert("year = " + varfromYear)

        //this.setState({
        //    fromYear: varfromYear,
        //    fromMonth: varfromMonth
        //});

        if(this.isInputValid()){
            //window.open(`${this.state.url}merchId=${this.state.searchSingleId}&upldDate=${this.state.fromMonth}/${this.state.fromYear}`, "_blank");

            //alert("searchSingleId = " + this.state.searchSingleId)
            //alert("month = " + this.state.fromMonth)
            //alert("year = " + this.state.fromYear)
            //axios(this.state.url + "merchId="+this.state.searchSingleId+"&upldDate="+this.state.fromMonth+"/"+this.state.fromYear, {
            axios(this.state.url + "merchId="+this.state.searchSingleId+"&upldDate="+varfromMonth+"/"+varfromYear, {
                headers: {'Authorization': `Bearer ${localStorage.getItem('accessToken')}`},
                method: "GET",
                responseType: "blob"

            }).then(response => {                
                
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    //IE11 and the legacy version Edge support
                    console.log("IE & Edge");
                    let blob = new Blob([response.data], { type: "text/html" });
                    window.navigator.msSaveOrOpenBlob(blob, "Merchant SOA.pdf");
                } else {// other browsers
                    console.log("response data = " + response.data);
                    const file = new Blob([response.data], { type: "application/pdf" });
                    console.log("file = " + file);    
                    //Build a URL from the file
                    const fileURL = URL.createObjectURL(file);
                    console.log("fileURL = " + fileURL);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                }
                
             }).catch(error =>{ 
                //console.log("err: "+JSON.stringify(error))
                console.log(error);
                this.setState({
                    fetchMessage: 'Sorry, there is/are no recorded transaction/s for the date you selected.'
                })                                     
            }) ;

        }
           
    }

        
          

    render(){                      
        const {legalName, corpName} = this.state.names;                    
        return(                               
	    <div>	
            <BodyHeaderDiv>
                <BodyHeaderText>Statement of Account</BodyHeaderText>
            </BodyHeaderDiv>
            <ContentDiv>
            <Row>
                <Col>
                    <Row>
                        <Col>
                        <span style={{fontSize:'11px', color:'red', lineHeight:'5px'}}>
                        {renderHTML(this.state.fetchMessage)}
                        </span>
                        </Col>
                    </Row>
                    <Row>
                    <Col md={3}></Col>                
                <Col md={6}>
                <Form onSubmit={this.handleSubmit}>                          
                    <Form.Label size='sm' style={{fontWeight:'bold'}}>Merchant ID</Form.Label>
                    <Form.Row>                        
                    <Form.Group as ={Col} sm={this.state.btnShow?12:10} controlId="searchSingleId" onChange={this.handleChange} onBlur={this.blurChange}>
                            <Form.Control size='sm' type="text" value={this.state.searchSingleId} disabled={this.state.checkedAllReport} maxLength={10}></Form.Control>
                        </Form.Group>    
                        <Form.Group as={Col} hidden={this.state.btnShow}>                            
                            {/* <Link to='/merchantPicker' onClick={this.windowOpen}><MidCifBtn>...</MidCifBtn></Link> */}
                            <MerchantPicker  userId = {this.state.cu.user.userId} getMerchant = {this.selectMerchantPicker}/>
                        </Form.Group>                                                                                        
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="legalName" onChange={this.handleChange}>
                            <Form.Label size='sm' style={{fontWeight:'bold'}}>Legal Name</Form.Label>
                            <Form.Control  type="text" value={legalName} size='sm' disabled ></Form.Control>
                        </Form.Group>
                    </Form.Row>

                    <Form.Label size='sm' style={{fontWeight:'bold'}}>DBA Name</Form.Label>
                    <Form.Row>
                        <Form.Group as={Col} sm={this.state.btnShow?12:10} controlId="dbaName" onChange={this.handleChange}>                            
                            <Form.Control type="text" value={corpName} size='sm' disabled></Form.Control>                            
                        </Form.Group>
                        <Form.Group as={Col} hidden={this.state.btnShow}>
                            <MerchantPicker  userId = {this.state.cu.user.userId} getMerchant = {this.selectMerchantPicker}/>
                        </Form.Group> 
                    </Form.Row>
                    <Form.Label size='sm' style={{fontWeight:'bold'}}>Date</Form.Label>
                    <Form.Row>                                                
                        <Form.Group as={Col} controlId="fromMonth" onChange={this.handleChange}>                                                            
                            <Form.Control as="select" size='sm' value={this.state.fromMonth}>
                            {   allMonths.map((option, index) =>                             
                                <option key={index} value={option.id}>{option.month}</option> )  
                            }                              
                            </Form.Control>                                                                
                        </Form.Group>                        
                        <Form.Group as={Col} controlId="fromYear" onChange={this.handleChange}>                                                                                            
                            <Form.Control as="select" size='sm' value={this.state.fromYear}>
                            {   retentionYears.sort((a,b) => b - a).map((option, index) =>                                                                                              
                                <option key={index} value={option}>{option}</option>)
                            }   

                         
                            </Form.Control>                                                                
                        </Form.Group>                                                         
                    </Form.Row>                                 
                    <div align="center">
                    <SubmitBtn style={{color:'#FFFFFF'}}>View Reports</SubmitBtn>                                                 
                    </div>                  
                </Form>  
                    </Col>
                    <Col md={3}>
                    </Col>
                    </Row>
                </Col>
                
                </Row>
                </ContentDiv>        
                <Modal show={this.state.loading} backdrop={'static'}  centered={true} backdropClassName='fade' dialogClassName="modal-bdox">  
                    <div>
                        <OverlayLoader
                            color={'#0B2972'}
                            loader="ClipLoader"
                            text="Loading..."
                            active={true}
                            backGroundColor={'black'}
                            opacity=".9">
                        </OverlayLoader>                
                    </div>                                  
                </Modal>                
            </div>

        )
    }
}


